import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestAuthentication } from '../../../actions/authentication';
import { onConsultantCianCloseNoAuth, requestChat } from '../../../actions/consultantCianChat';
import { getUser } from '../../../selectors/user';
import { TDispatch } from '../../../types/redux';

export function useConsultantCianChat() {
  const dispatch: TDispatch = useDispatch();
  const user = useSelector(getUser);

  const handleOpenChat = React.useCallback(() => {
    if (!user?.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => requestChat(),
          onCloseNoAuth: () => onConsultantCianCloseNoAuth(),
        }),
      );

      return;
    }

    dispatch(requestChat());
  }, [dispatch, user]);

  return React.useMemo(
    () => ({
      handleOpenChat,
    }),
    [handleOpenChat],
  );
}
